import React, { memo, ReactNode } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { GHLLayout } from 'Components/Layouts';
import { GHLProvider } from 'Context/GHL';

interface Props {
  children: ReactNode;
}

// GHL Wrapper - provides GHL context and minimal layout for embedded views
const GHLWrapperContainer = ({ children }: Props) => (
  <GHLProvider>
    <GHLLayout>{children}</GHLLayout>
  </GHLProvider>
);

const GHLWrapperContainerMemo = memo(GHLWrapperContainer, areEqual);

export { GHLWrapperContainerMemo as GHLWrapperContainer };
